import React from 'react';
import PropTypes from 'prop-types';
import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { saveAs } from 'file-saver';
import Dropdown from 'react-dropdown';
import './custom-dropdown.css';

// ExportButtons component definition
const ExportButtons = ({ data, columns, fileName }) => {
  // Function to handle exporting to PDF
  const generatePDF = () => {
    /* eslint-disable new-cap */
    const doc = new jsPDF('landscape');

    // Prepare the table data for the PDF
    const tableData = data.map((row) => columns.map((column) => row[column.field]));

    // Prepare the table headers for the PDF
    const tableHeaders = columns.map((column) => column.headerName);

    // Generate the table in the PDF
    doc.autoTable({
      head: [tableHeaders],
      body: tableData,
    });

    // Save the generated PDF
    doc.save(`${fileName}.pdf`);
  };

  // Function to handle exporting to Excel
  const generateExcel = () => {
    // Prepare the worksheet data for the Excel file
    const worksheetData = [
      columns.map((column) => column.headerName), // Header row
      ...data.map((row) => columns.map((column) => row[column.field])),
    ];

    // Create a new worksheet and workbook
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    // Create a Blob and save the workbook
    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });
    const blob = new Blob([excelBuffer], {
      type: 'application/octet-stream',
    });

    saveAs(blob, `${fileName}.xlsx`);
  };

  const exportOptions = [
    { value: 'export as', label: 'Export As' },
    { value: 'pdf', label: 'PDF' },
    { value: 'excel', label: 'Excel' },
  ];

  const handleExport = (option) => {
    if (option.value === 'pdf') {
      generatePDF();
    } else if (option.value === 'excel') {
      generateExcel();
    }
  };

  return (
    <Dropdown
      options={exportOptions}
      onChange={handleExport}
      placeholder="Export As"
      controlClassName="bg-gray-800 text-white py-2 px-4 rounded cursor-pointer"
      arrowClosed={<span className="arrow-closed" />}
      arrowOpen={<span className="arrow-open" />}
      menuClassName="bg-gray-700 text-white rounded shadow-md"
    />
  );
};

ExportButtons.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      headerName: PropTypes.string.isRequired,
      field: PropTypes.string.isRequired,
    }),
  ).isRequired,
  fileName: PropTypes.string.isRequired,
};

export default ExportButtons;
